// Coasters Product Functionality
console.log('Product Coasters JS loaded');
console.log('Body classes:', document.body.className);

class CoastersProduct {
  constructor() {
    console.log('🚀 CoastersProduct initialized - starting constructor');

    // State
    this.selectedSize = 'Square';
    this.selectedPrintType = 'FrontOnly'; // Print Side
    this.selectedColourType = 'FullColour'; // Print Type (colour model)
    this.selectedQuantity = 250;
    this.isRushed = false;
    this.expandedQuantities = false; // Track if quantities over 5000 are shown

    // Live pricing cache
    this.productData = null;
    this.currentUnitPrice = 0;

    // Constants
    this.UNITS_PER_CARTON = 1000;
    this.RUSH_MULTIPLIER = 1.3; // 30% surcharge
    this.COASTER_MATERIAL_GSM = 365; // Material weight (GSM) for coasters

    // Membership pricing on coasters page:
    // - Exclude coasters from receiving discounts themselves
    // - Allow other products in the cart to show discounts
    // - Do NOT remove discount markup inside the cart drawer or checkout

    // Sizes that support Full Colour Print - coasters don't have full colour
    this.fullColourSizes = [];

    // Variant mapping for quantity-based pricing
    // Updated with actual coaster variant IDs from Shopify admin
    this.variantMapping = {
      "Square_FrontOnly": {
        "250": "50729180823834",
        "500": "50729180856602",
        "1000": "50729180889370",
        "2000": "50729180922138",
        "3000": "50729180954906",
        "4000": "50729180987674",
        "5000": "50729181020442",
        "10000": "50793540157722",  // TO BE FILLED IN
        "20000": "50793540190490",  // TO BE FILLED IN
        "30000": "50793540223258",  // TO BE FILLED IN
        "40000": "50793540256026",  // TO BE FILLED IN
        "50000": "50793540288794"   // TO BE FILLED IN
      },
      "Square_FrontBack": {
        "250": "50737993711898",
        "500": "50737993744666",
        "1000": "50737993777434",
        "2000": "50737993810202",
        "3000": "50737993842970",
        "4000": "50737993875738",
        "5000": "50737993908506",
        "10000": "50793540321562",  // TO BE FILLED IN
        "20000": "50793540354330",  // TO BE FILLED IN
        "30000": "50793540387098",  // TO BE FILLED IN
        "40000": "50793540419866",  // TO BE FILLED IN
        "50000": "50793540452634"  // TO BE FILLED IN
      },
      "Circle_FrontOnly": {
        "250": "50737993941274",
        "500": "50737993974042",
        "1000": "50737994006810",
        "2000": "50737994039578",
        "3000": "50737994072346",
        "4000": "50737994105114",
        "5000": "50737994137882",
        "10000": "50793540485402", // TO BE FILLED IN
        "20000": "50793540518170", // TO BE FILLED IN
        "30000": "50793540550938", // TO BE FILLED IN
        "40000": "50793540583706", // TO BE FILLED IN
        "50000": "50793540616474"  // TO BE FILLED IN
      },
      "Circle_FrontBack": {
        "250": "50737994170650",
        "500": "50737994203418",
        "1000": "50737994236186",
        "2000": "50737994268954",
        "3000": "50737994301722",
        "4000": "50737994334490",
        "5000": "50737994367258",
        "10000": "50793540649242", // TO BE FILLED IN
        "20000": "50793540682010", // TO BE FILLED IN
        "30000": "50793540714778", // TO BE FILLED IN
        "40000": "50793540747546", // TO BE FILLED IN
        "50000": "50793540780314"  // TO BE FILLED IN
      }
    };

    this.init().catch(error => console.error('❌ CoastersProduct initialization error:', error));
  }

  async init() {
    this.setupSizeSelector();
    this.setupPrintTypeSelector();
    this.setupColourTypeSelector();
    this.setupTurnaroundSelector();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.setupShippingCalculator();
    this.setupDynamicDescription();
    this.setupTooltips();
    this.updatePrintTypeAvailability();
    this.setupRushedIncompatibilityPopup();
    this.updateRushedAvailability();
    this.updateUploadFields();
    await this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }

  setupSizeSelector() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up size selector, found buttons:', sizeButtons.length);

    sizeButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log('Size button clicked:', btn.dataset.size);

        // Update selection
        sizeButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedSize = btn.dataset.size;
        console.log('Size selected:', this.selectedSize);

        this.updatePrintTypeAvailability();
        this.updatePricingTable();
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }

  setupPrintTypeSelector() {
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('[PrintType Debug] Setting up print type selector, found buttons:', printButtons.length);

    printButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('disabled')) {
          return;
        }

        // Update selection
        printButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        this.selectedPrintType = btn.dataset.printType;
        console.log('Print type selected:', this.selectedPrintType);

        this.updatePricingTable();
        this.updateMediaGalleryForSelectedVariant();
        this.updateUploadFields();
      });
    });
  }

  setupColourTypeSelector() {
    const colourButtons = document.querySelectorAll('.colour-type-btn');
    if (!colourButtons || colourButtons.length === 0) return;

    colourButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        // Update selection UI
        colourButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');

        // Persist selection
        this.selectedColourType = btn.dataset.colourType || 'FullColour';
        console.log('Colour print type selected:', this.selectedColourType);
      });
    });
  }

  setupTurnaroundSelector() {
    const turnaroundPills = document.querySelectorAll('.turnaround-pill');
    turnaroundPills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Check if this is the rushed button and it's disabled
        if (pill.dataset.turnaround === 'rushed' && pill.classList.contains('disabled')) {
          this.showRushedIncompatibilityPopup();
          return;
        }

        // Update selection
        turnaroundPills.forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');

        this.isRushed = pill.dataset.turnaround === 'rushed';
        console.log('Turnaround selected:', pill.dataset.turnaround, 'isRushed:', this.isRushed);

        this.updatePricingTable();
        this.updateShippingCalculator();
      });
    });
  }

  setupShippingCalculator() {
    // Initialize the shipping calculator on page load
    this.updateShippingCalculator();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      console.log('Shipping calculator elements not found');
      return;
    }

    // Determine production days and shipping times based on turnaround selection
    // For coasters: always use standard timing since rushed is disabled
    const productionDays = 10;
    const minDeliveryDays = 11;
    const maxDeliveryDays = 13;

    // Calculate dates
    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    const doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    const minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);

    // Format dates
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    // Update delivery range - always standard for coasters
    const productionTimeText = 'Standard (10 business days)';

    if (minDeliveryDays === maxDeliveryDays) {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(doorstepDate)}`;
    } else {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    // Update timeline dates
    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (0 = Sunday, 6 = Saturday)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  setupDynamicDescription() {
    // Initialize the description update
    this.updateDynamicDescription();

    // Setup accordion dropdown functionality (only one open at a time)
    this.setupAccordionBehavior('.dynamic-description'); // Desktop version
    this.setupAccordionBehavior('.dynamic-description-mobile'); // Mobile version

    // Auto-open the first tab (Description) on page load
    this.openDescriptionTab();
  }

  openDescriptionTab() {
    // Open description tab on desktop
    const desktopDescriptionTitle = document.querySelector('.dynamic-description .dropdown-title[data-target="description-content"]');
    const desktopDescriptionContent = document.getElementById('description-content');

    if (desktopDescriptionTitle && desktopDescriptionContent) {
      desktopDescriptionTitle.classList.add('active');
      desktopDescriptionContent.classList.add('active');
    }

    // Open description tab on mobile
    const mobileDescriptionTitle = document.querySelector('.dynamic-description-mobile .dropdown-title[data-target="description-content-mobile"]');
    const mobileDescriptionContent = document.getElementById('description-content-mobile');

    if (mobileDescriptionTitle && mobileDescriptionContent) {
      mobileDescriptionTitle.classList.add('active');
      mobileDescriptionContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const dropdownTitles = container.querySelectorAll('.dropdown-title');

    dropdownTitles.forEach((title, index) => {
      // Force bold styling directly on the element
      title.style.fontWeight = '700';
      title.style.setProperty('font-weight', '700', 'important');

      // Remove any existing listeners to prevent duplicates
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);

      newTitle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const targetId = newTitle.getAttribute('data-target');
        const content = document.getElementById(targetId);
        const arrow = newTitle.querySelector('.dropdown-arrow');

        if (content) {
          const isCurrentlyActive = newTitle.classList.contains('active');

          // Close all dropdowns in this container first
          container.querySelectorAll('.dropdown-title').forEach(otherTitle => {
            const otherTargetId = otherTitle.getAttribute('data-target');
            const otherContent = document.getElementById(otherTargetId);
            const otherArrow = otherTitle.querySelector('.dropdown-arrow');

            if (otherContent) {
              otherTitle.classList.remove('active');
              otherContent.classList.remove('active');
              if (otherArrow) {
                otherArrow.style.transform = 'rotate(0deg)';
              }
            }
          });

          // If this wasn't active, open it
          if (!isCurrentlyActive) {
            newTitle.classList.add('active');
            content.classList.add('active');
            if (arrow) {
              arrow.style.transform = 'rotate(180deg)';
            }
          }
        }
      });

      // Set initial state - Description opens by default, plus rows marked active in markup.
      const targetId = newTitle.getAttribute('data-target');
      const content = document.getElementById(targetId);
      const arrow = newTitle.querySelector('.dropdown-arrow');

      if (content) {
        const shouldOpen = index === 0 || newTitle.classList.contains('active') || content.classList.contains('active');

        if (shouldOpen) {
          newTitle.classList.add('active');
          content.classList.add('active');
          if (arrow) {
            arrow.style.transform = 'rotate(180deg)';
          }
        } else {
          newTitle.classList.remove('active');
          content.classList.remove('active');
          if (arrow) {
            arrow.style.transform = 'rotate(0deg)';
          }
        }
      }
    });
  }

  updateDynamicDescription() {
    const descriptionData = this.getDescriptionData();

    // Update desktop version
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');

    // Update mobile version
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');

    if (descriptionData) {
      // Update desktop
      if (descriptionContent) {
        descriptionContent.innerHTML = descriptionData.description;
      }
      if (specificationContent) {
        specificationContent.innerHTML = descriptionData.specification;
      }
      if (dielinesContent) {
        dielinesContent.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) {
        howItWorksContent.innerHTML = descriptionData.howItWorks;
      }

      // Update mobile (same content)
      if (descriptionContentMobile) {
        descriptionContentMobile.innerHTML = descriptionData.description;
      }
      if (specificationContentMobile) {
        specificationContentMobile.innerHTML = descriptionData.specification;
      }
      if (dielinesContentMobile) {
        dielinesContentMobile.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) {
        howItWorksContentMobile.innerHTML = descriptionData.howItWorks;
      }
    }
  }

  getDescriptionData() {
    const shapeDescriptions = {
      "Square": {
        description: `
          <p>Our Square Custom Coasters (95mm) are perfect for promotional events, restaurants, cafés, and corporate branding. Built for durability with premium ${this.COASTER_MATERIAL_GSM}gsm paperboard, these water-resistant coasters provide excellent surface protection while showcasing your brand with professional-quality printing.</p>
          <p><strong>Available in Front Only or Front & Back printing:</strong></p>
          <p>• <strong>Front Only:</strong> Cost-effective single-side printing, perfect for simple logos and messaging<br>
          • <strong>Front & Back:</strong> Maximum brand impact with designs on both sides</p>
          <p><strong>Full-coverage (edge-to-edge) print:</strong> Supported — supply artwork with a 2mm bleed on all sides for best results. For large black areas use rich black (CMYK 40-40-40-100); small black text should be 100% K.</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Size:</span> <span class="spec-value">95mm x 95mm (Square)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">${this.COASTER_MATERIAL_GSM}gsm FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">Water-resistant finish</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Offset printing</span></li>
            <li><span class="spec-label">Print Options:</span> <span class="spec-value">Front Only or Front & Back</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Production Time:</span> <span class="spec-value">Standard (10 business days)</span></li>
            <li><span class="spec-label">Packaging:</span> <span class="spec-value">Bulk packed in protective cartons</span></li>
        </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/Square_Circle_Coaster_Template.pdf?v=1755750105" class="download-btn" target="_blank" rel="noopener">📄 Download Square & Circle Coaster Template (PDF)</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Choose Your Options</strong><br>Select shape, print side, quantity, and upload your artwork files.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom coasters go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "Circle": {
        description: `
          <p>Our Circle Custom Coasters (95mm) offer a modern, rounded design perfect for cafés, bars, restaurants, and events. Made from premium ${this.COASTER_MATERIAL_GSM}gsm paperboard with water-resistant coating, these durable coasters provide excellent surface protection while delivering standout brand visibility.</p>
          <p><strong>Available in Front Only or Front & Back printing:</strong></p>
          <p>• <strong>Front Only:</strong> Single-side printing for clean, simple branding and cost-effectiveness<br>
          • <strong>Front & Back:</strong> Double-sided printing for maximum brand exposure and professional presentation</p>
          <p><strong>Full-coverage (edge-to-edge) print:</strong> Supported — supply artwork with a 2mm bleed on all sides for best results. For large black areas use rich black (CMYK 40-40-40-100); small black text should be 100% K.</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Size:</span> <span class="spec-value">95mm diameter (Circle)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">${this.COASTER_MATERIAL_GSM}gsm FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">Water-resistant finish</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Offset printing</span></li>
            <li><span class="spec-label">Print Options:</span> <span class="spec-value">Front Only or Front & Back</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Production Time:</span> <span class="spec-value">Standard (10 business days)</span></li>
            <li><span class="spec-label">Packaging:</span> <span class="spec-value">Bulk packed in protective cartons</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/Square_Circle_Coaster_Template.pdf?v=1755750105" class="download-btn" target="_blank" rel="noopener">📄 Download Square & Circle Coaster Template (PDF)</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Choose Your Options</strong><br>Select shape, print side, quantity, and upload your artwork files.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom coasters go into production — standard turnaround is 10 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      }
    };

    return shapeDescriptions[this.selectedSize] || shapeDescriptions["Square"];
  }

  setupTooltips() {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon[data-tooltip]');

    tooltipIcons.forEach(icon => {
      let tooltip = null;

      const showTooltip = (e) => {
        // Remove any existing tooltips
        document.querySelectorAll('.tooltip-popup').forEach(t => t.remove());

        const tooltipText = icon.getAttribute('data-tooltip');
        if (!tooltipText) return;

        // Create tooltip element
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.innerHTML = tooltipText;

        // Style the tooltip
        Object.assign(tooltip.style, {
          position: 'absolute',
          background: '#000000',
          color: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.4',
          maxWidth: '300px',
          width: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          zIndex: '9999',
          opacity: '0',
          visibility: 'hidden',
          transition: 'all 0.2s ease',
          pointerEvents: 'none'
        });

        // Add to DOM - append to the icon's parent container for better positioning
        const container = icon.closest('.form__label') || icon.parentElement;
        container.style.position = 'relative';
        container.appendChild(tooltip);

        // Position tooltip relative to icon
        const iconRect = icon.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // Get tooltip dimensions after adding to DOM
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.visibility = 'hidden';

        // Calculate position relative to container
        const iconLeft = iconRect.left - containerRect.left;
        const iconTop = iconRect.top - containerRect.top;

        // Position above the icon, centered horizontally
        let left = iconLeft + (iconRect.width / 2) - (tooltipRect.width / 2);
        let top = iconTop - tooltipRect.height - 8;

        // Keep tooltip within viewport
        const viewportWidth = window.innerWidth;
        const tooltipLeftInViewport = containerRect.left + left;
        const tooltipRightInViewport = tooltipLeftInViewport + tooltipRect.width;

        // Adjust horizontal position if going off screen
        if (tooltipLeftInViewport < 10) {
          left = 10 - containerRect.left;
        } else if (tooltipRightInViewport > viewportWidth - 10) {
          left = (viewportWidth - 10 - containerRect.left) - tooltipRect.width;
        }

        // If no room above, show below
        if (containerRect.top + top < 10) {
          top = iconTop + iconRect.height + 8;
        }

        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';

        // Show tooltip
        requestAnimationFrame(() => {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
      };

      const hideTooltip = () => {
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
          setTimeout(() => {
            if (tooltip && tooltip.parentNode) {
              tooltip.parentNode.removeChild(tooltip);
            }
            tooltip = null;
          }, 200);
        }
      };

      // Add event listeners
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });

    // Clean up tooltips on page interactions
    document.addEventListener('scroll', () => {
      document.querySelectorAll('.tooltip-popup').forEach(t => {
        if (t.parentNode) t.parentNode.removeChild(t);
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.tooltip-icon')) {
        document.querySelectorAll('.tooltip-popup').forEach(t => {
          if (t.parentNode) t.parentNode.removeChild(t);
        });
      }
    });
  }

  setupRushedIncompatibilityPopup() {
    const rushedBtn = document.getElementById('rushed-turnaround-btn');

    if (rushedBtn) {
      // Show popup on hover when disabled
      rushedBtn.addEventListener('mouseenter', () => {
        if (rushedBtn.classList.contains('disabled')) {
          this.showRushedIncompatibilityPopup();
        }
      });

      // Hide popup on mouse leave
      rushedBtn.addEventListener('mouseleave', () => {
        this.hideRushedIncompatibilityPopup();
      });
    }
  }

  showRushedIncompatibilityPopup() {
    // Remove any existing popups
    this.hideRushedIncompatibilityPopup();

    const rushedBtn = document.getElementById('rushed-turnaround-btn');
    if (!rushedBtn) return;

    // Get button position
    const rect = rushedBtn.getBoundingClientRect();

    // Create popup element
    const popup = document.createElement('div');
    popup.className = 'turnaround-incompatible-popup show';
    popup.id = 'rushed-incompatible-popup-new';
    popup.textContent = 'Rushed print is not available for coasters';

    // Style the popup
    Object.assign(popup.style, {
      position: 'fixed',
      background: '#dc2626',
      color: 'white',
      padding: '0.75rem 1rem',
      borderRadius: '8px',
      fontSize: '0.85rem',
      fontWeight: '500',
      whiteSpace: 'nowrap',
      zIndex: '99999',
      boxShadow: '0 8px 16px rgba(220, 38, 38, 0.3)',
      opacity: '1',
      visibility: 'visible'
    });

    // Position above the button
    popup.style.left = rect.left + (rect.width / 2) - 100 + 'px';
    popup.style.top = rect.top - 50 + 'px';

    // Add to document
    document.body.appendChild(popup);

    // Auto-hide after 3 seconds if user hovers away
    setTimeout(() => {
      this.hideRushedIncompatibilityPopup();
    }, 3000);
  }

  hideRushedIncompatibilityPopup() {
    const existingPopup = document.getElementById('rushed-incompatible-popup-new');
    if (existingPopup) {
      existingPopup.remove();
    }
  }

  updateRushedAvailability() {
    const rushedBtn = document.getElementById('rushed-turnaround-btn');
    const unavailableIndicator = rushedBtn?.querySelector('.unavailable-indicator');

    if (rushedBtn && unavailableIndicator) {
      // For coasters, rushed is always disabled
      rushedBtn.classList.add('disabled');
      unavailableIndicator.style.display = 'inline';

      // Switch to Standard if Rushed was somehow selected
      if (this.isRushed) {
        const standardBtn = document.querySelector('[data-turnaround="standard"]');
        if (standardBtn) {
          standardBtn.click();
        }
      }
    }
  }

  openDescriptionTab() {
    // Find the description tab button and content
    const descriptionTab = document.querySelector('[data-tab="description"]');
    const descriptionContent = document.querySelector('[data-tab-content="description"]');

    if (descriptionTab && descriptionContent) {
      // Remove active class from all tabs and contents
      document.querySelectorAll('[data-tab]').forEach(tab => tab.classList.remove('active'));
      document.querySelectorAll('[data-tab-content]').forEach(content => content.classList.remove('active'));

      // Add active class to description tab and content
      descriptionTab.classList.add('active');
      descriptionContent.classList.add('active');
    }
  }





  setupFormSubmission() {
    // Handle form submission
    const form = document.getElementById('product-form-coasters');
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }

    // Also setup direct click handler for the add to cart button
    const addToCartBtn = document.getElementById('custom-add-to-cart-btn');
    if (addToCartBtn) {
      console.log('Setting up add to cart button click handler');
      addToCartBtn.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('Add to cart button clicked');
        this.addToCart();
      });
    } else {
      console.error('Add to cart button not found!');
    }
  }

  setupFileUpload() {
    console.log('🔧 CoastersProduct: Setting up file upload...');

    // Setup File 1
    this.setupSingleFileUpload('', 'properties[Design File]');
    // Setup File 2
    this.setupSingleFileUpload('2', 'properties[Back Design File]');
  }

  setupSingleFileUpload(suffix, inputName) {
    const fileInput = document.querySelector(`input[type="file"][name="${inputName}"]`);
    if (!fileInput) {
      console.log(`❌ File upload input not found for ${inputName}`);
      return;
    }

    const uploadArea = document.querySelector(`div[id^="uploadArea${suffix}-"]`);
    const removeButton = document.querySelector(`button[id^="removeFile${suffix}-"]`);

    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';

        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0], suffix);
        }
      });
    }

    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file, suffix);
    });

    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection(suffix, inputName);
      });
    }
  }

  handleFileSelection(file, suffix = '') {
    const uploadArea = document.querySelector(`div[id^="uploadArea${suffix}-"]`);
    const imagePreview = document.querySelector(`img[id^="imagePreview${suffix}-"]`);
    const filePreviewArea = document.querySelector(`div[id^="filePreviewArea${suffix}-"]`);
    const fileName = document.querySelector(`div[id^="fileName${suffix}-"]`);
    const fileSize = document.querySelector(`div[id^="fileSize${suffix}-"]`);

    if (!file) {
      const inputName = suffix === '2' ? 'properties[Back Design File]' : 'properties[Design File]';
      this.clearFileSelection(suffix, inputName);
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      const inputName = suffix === '2' ? 'properties[Back Design File]' : 'properties[Design File]';
      this.clearFileSelection(suffix, inputName);
      return;
    }

    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      if (imagePreview) imagePreview.style.display = 'none';
    }
  }

  clearFileSelection(suffix = '', inputName = 'properties[Design File]') {
    const fileInput = document.querySelector(`input[type="file"][name="${inputName}"]`);
    const uploadArea = document.querySelector(`div[id^="uploadArea${suffix}-"]`);
    const imagePreview = document.querySelector(`img[id^="imagePreview${suffix}-"]`);
    const filePreviewArea = document.querySelector(`div[id^="filePreviewArea${suffix}-"]`);

    if (fileInput) fileInput.value = '';
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';
  }

  updateUploadFields() {
    const uploadArea2Container = document.getElementById('design-upload-section-2');
    const uploadLabel1 = document.getElementById('upload-label-1');
    if (uploadArea2Container) {
      if (this.selectedPrintType === 'FrontBack') {
        uploadArea2Container.style.display = 'block';
        if (uploadLabel1) uploadLabel1.textContent = 'Design File Upload (Front)';
      } else {
        uploadArea2Container.style.display = 'none';
        if (uploadLabel1) uploadLabel1.textContent = 'Design File Upload';
        this.clearFileSelection('2', 'properties[Back Design File]');
      }
    }
  }

  updatePrintTypeAvailability() {
    // Coasters don't have full colour restrictions
    // All print types are available for all sizes
  }

  getPricingKey() {
    return `${this.selectedSize}_${this.selectedPrintType}`;
  }

  async loadProductData() {
    if (this.productData) return this.productData;

    try {
      // First try to get from existing ProductJSON script
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (productScript) {
        this.productData = JSON.parse(productScript.textContent);
        console.log('Loaded product data from script:', this.productData.handle);
        return this.productData;
      }

      // Fallback: fetch from API using product handle from URL
      const pathParts = window.location.pathname.split('/');
      const handle = pathParts[pathParts.indexOf('products') + 1];

      if (handle) {
        const response = await fetch(`/products/${handle}.js`);
        this.productData = await response.json();
        console.log('Loaded product data from API:', this.productData.handle);
        return this.productData;
      }

      throw new Error('Could not determine product handle');
    } catch (error) {
      console.error('Failed to load product data:', error);
      return null;
    }
  }

  async updatePricingTable() {
    const tbody = document.getElementById('quantity-grid-body');
    if (!tbody) return;

    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];

    console.log('Updating pricing for:', pricingKey, variants);

    if (!variants) {
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }

    // Load product data for price lookup (but don't require it)
    await this.loadProductData();

    tbody.innerHTML = '';

    // Get available quantities for this configuration
    const quantities = Object.keys(variants).map(q => parseInt(q)).sort((a, b) => a - b);

    // Split quantities into standard (≤5000) and extended (>5000)
    const standardQuantities = quantities.filter(q => q <= 5000);
    const extendedQuantities = quantities.filter(q => q > 5000);

    // Create rows for standard quantities (up to 5000)
    for (let i = 0; i < standardQuantities.length; i++) {
      const qty = standardQuantities[i];
      const row = this.createQuantityRow(qty, variants, i === 0 && this.selectedQuantity === null);
      tbody.appendChild(row);
    }

    // Add "View more" button row if there are extended quantities
    if (extendedQuantities.length > 0) {
      const viewMoreRow = this.createViewMoreRow();
      tbody.appendChild(viewMoreRow);

      // Create rows for extended quantities (above 5000) - initially hidden
      for (let i = 0; i < extendedQuantities.length; i++) {
        const qty = extendedQuantities[i];
        const row = this.createQuantityRow(qty, variants, false);
        row.classList.add('extended-quantity-row');

        // FORCE HIDE: Use display none initially for guaranteed hiding
        row.style.display = 'none';
        row.style.overflow = 'hidden';
        row.style.transition = 'max-height 0.5s ease-in-out, opacity 0.4s ease-in-out, transform 0.5s ease-in-out';
        row.style.transformOrigin = 'top center';

        tbody.appendChild(row);
      }
    }

    this.updateRowSelection();
    this.updateSelectedQuantityDisplay();
    this.updateOrderSummary();
  }

  createQuantityRow(qty, variants, shouldSelect = false) {
    const pricingKey = this.getPricingKey();
    const variantId = variants[qty.toString()];

    // Try to find variant in product data
    let variant = null;
    let variantPrice = 0;
    let unitPrice = 0;

    if (this.productData) {
      variant = this.productData.variants.find(v => v.id == variantId);
    }

    console.log(`[Pricing Debug] ${pricingKey} - Qty: ${qty}, VariantID: ${variantId}, Found: ${!!variant}`);

    if (variant) {
      // Use live Shopify pricing
      if (typeof variant.price === 'string') {
        variantPrice = parseFloat(variant.price);
      } else {
        // Assume cents, convert to dollars
        variantPrice = variant.price / 100;
      }
      unitPrice = variantPrice / qty;
    } else {
      // Fallback: calculate estimated pricing based on quantity tiers
      console.warn(`Using fallback pricing for ${pricingKey} ${qty} units (variant ${variantId} not found)`);

      // Enhanced tiered pricing fallback for coasters
      if (qty >= 50000) unitPrice = 0.12;
      else if (qty >= 40000) unitPrice = 0.13;
      else if (qty >= 30000) unitPrice = 0.14;
      else if (qty >= 20000) unitPrice = 0.15;
      else if (qty >= 10000) unitPrice = 0.16;
      else if (qty >= 5000) unitPrice = 0.18;
      else if (qty >= 4000) unitPrice = 0.22;
      else if (qty >= 3000) unitPrice = 0.26;
      else if (qty >= 2000) unitPrice = 0.32;
      else if (qty >= 1000) unitPrice = 0.42;
      else if (qty >= 500) unitPrice = 0.55;
      else unitPrice = 0.75;

      // Adjust for print type
      if (pricingKey.includes('FrontBack')) {
        unitPrice *= 1.4; // Front & back costs more
      }

      variantPrice = unitPrice * qty;
    }

    const row = document.createElement('tr');
    row.classList.add('quantity-row');
    row.dataset.quantity = qty;

    // Make entire row clickable
    row.addEventListener('click', () => {
      const radio = row.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = true;
        this.selectedQuantity = qty;
        this.currentUnitPrice = unitPrice;
        this.updateRowSelection();
        this.updateSelectedQuantityDisplay();
        this.updateMediaGalleryForSelectedVariant();
      }
    });

    // Radio button
    const radioCell = document.createElement('td');
    const radio = document.createElement('input');
    radio.type = 'radio';
    radio.name = 'quantity_selection';
    radio.value = qty;
    radio.addEventListener('change', () => {
      if (radio.checked) {
        this.selectedQuantity = qty;
        this.currentUnitPrice = unitPrice;
        this.updateRowSelection();
        this.updateSelectedQuantityDisplay();
        this.updateMediaGalleryForSelectedVariant();
      }
    });

    // Pre-select if needed or maintain current selection
    if (shouldSelect || qty === this.selectedQuantity) {
      radio.checked = true;
      this.selectedQuantity = qty;
      this.currentUnitPrice = unitPrice;
      row.classList.add('selected');
    }

    radioCell.appendChild(radio);
    row.appendChild(radioCell);

    // Quantity
    const qtyCell = document.createElement('td');
    qtyCell.textContent = qty.toLocaleString();
    row.appendChild(qtyCell);

    // Unit Price (apply membership discount for non-trade tiers)
    const unitPriceCell = document.createElement('td');
    unitPriceCell.style.textAlign = 'center';
    let unitHTML = `$${unitPrice.toFixed(2)}`;
    try {
      if (typeof window.MembershipPricing !== 'undefined') {
        const tier = window.MembershipPricing.getCustomerTier && window.MembershipPricing.getCustomerTier();
        if (tier && tier !== 'trade') {
          unitHTML = window.MembershipPricing.formatPriceWithDiscount(unitPrice, true, true);
        }
      }
    } catch (e) { }
    unitPriceCell.innerHTML = unitHTML;
    row.appendChild(unitPriceCell);

    // Total Price (apply membership discount for non-trade tiers)
    const totalCell = document.createElement('td');
    let totalHTML = `$${variantPrice.toFixed(2)}`;
    try {
      if (typeof window.MembershipPricing !== 'undefined') {
        const tier = window.MembershipPricing.getCustomerTier && window.MembershipPricing.getCustomerTier();
        if (tier && tier !== 'trade') {
          totalHTML = window.MembershipPricing.formatPriceWithDiscount(variantPrice, true, true);
        }
      }
    } catch (e) { }
    totalCell.innerHTML = totalHTML;
    row.appendChild(totalCell);

    return row;
  }

  createViewMoreRow() {
    const row = document.createElement('tr');
    row.classList.add('view-more-row');
    row.style.cursor = 'pointer';
    row.style.backgroundColor = 'white';
    row.style.borderTop = '2px solid #e2e8f0';
    row.style.borderBottom = '2px solid #e2e8f0';
    row.style.transition = 'background-color 0.2s ease';

    const cell = document.createElement('td');
    cell.setAttribute('colspan', '5');
    cell.style.textAlign = 'center';
    cell.style.padding = '1rem';
    cell.style.fontWeight = '500';
    cell.style.color = '#000000';

    const content = document.createElement('div');
    content.style.display = 'flex';
    content.style.alignItems = 'center';
    content.style.justifyContent = 'center';
    content.style.gap = '0.5rem';

    const icon = document.createElement('span');
    icon.style.fontSize = '1.2em';
    icon.style.transition = 'transform 0.3s ease';
    icon.style.transform = this.expandedQuantities ? 'rotate(180deg)' : 'rotate(0deg)';
    icon.textContent = '▼'; // Always use down arrow, rotation handles the direction

    const text = document.createElement('span');
    text.textContent = this.expandedQuantities ? 'View less quantities' : 'View more quantities (10K+)';

    content.appendChild(icon);
    content.appendChild(text);
    cell.appendChild(content);
    row.appendChild(cell);

    // Add click handler to toggle extended quantities
    row.addEventListener('click', () => {
      this.toggleExtendedQuantities();
    });

    // Add hover effects that match the summary box styling
    row.addEventListener('mouseenter', () => {
      // Match the summary box's light gray background
      row.style.backgroundColor = '#f8fafc'; // Light gray to match summary box
      cell.style.color = '#000000'; // Keep text black
    });

    row.addEventListener('mouseleave', () => {
      // Return to white background
      row.style.backgroundColor = 'white';
      cell.style.color = '#000000'; // Keep text black
    });

    return row;
  }

  toggleExtendedQuantities() {
    this.expandedQuantities = !this.expandedQuantities;

    const extendedRows = document.querySelectorAll('.extended-quantity-row');
    const viewMoreRow = document.querySelector('.view-more-row');

    // Apply animation to each row with staggered timing
    extendedRows.forEach((row, index) => {
      if (this.expandedQuantities) {
        // Expanding: First show the row, then animate
        row.style.display = 'table-row';
        row.style.maxHeight = '0px';
        row.style.opacity = '0';
        row.style.transform = 'scaleY(0)';

        setTimeout(() => {
          row.style.maxHeight = '80px';
          row.style.opacity = '1';
          row.style.transform = 'scaleY(1)';
        }, index * 30 + 10); // Small delay after showing
      } else {
        // Collapsing: Animate first, then hide
        setTimeout(() => {
          row.style.maxHeight = '0px';
          row.style.opacity = '0';
          row.style.transform = 'scaleY(0)';

          // After animation completes, fully hide the row
          setTimeout(() => {
            row.style.display = 'none';
          }, 500); // Wait for animation to complete
        }, index * 30);
      }
    });

    // Update the view more button while preserving center layout
    if (viewMoreRow) {
      const buttonContent = viewMoreRow.querySelector('td');
      if (buttonContent) {
        const icon = this.expandedQuantities ? '▲' : '▼';
        const text = this.expandedQuantities ? 'View less quantities' : 'View more quantities (10K+)';

        buttonContent.innerHTML = `
          <div style="display: flex; align-items: center; justify-content: center; gap: 0.5rem;">
            <span class="expand-arrow">${icon}</span>
            <span>${text}</span>
          </div>
        `;
      }
    }

    console.log(`Extended quantities ${this.expandedQuantities ? 'expanded' : 'collapsed'}`);
  }

  calculateUnitPrice() {
    // Return the cached unit price from live data
    return this.currentUnitPrice || 0;
  }

  // Helper method to calculate variant total price
  calculateVariantTotalPrice() {
    // Calculate total price from live variant data
    const unitPrice = this.calculateUnitPrice();
    const totalPrice = unitPrice * this.selectedQuantity;

    console.log(`[VariantTotalPrice] Unit: $${unitPrice}, Qty: ${this.selectedQuantity}, Total: $${totalPrice}`);

    return totalPrice;
  }

  updateRowSelection() {
    // Remove selection from all rows
    document.querySelectorAll('.quantity-row').forEach(row => {
      row.classList.remove('selected');
    });

    // Add selection to current row
    if (this.selectedQuantity) {
      const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`);
      if (selectedRow) {
        selectedRow.classList.add('selected');

        // If selected quantity is extended (>5000) and drawer is collapsed, expand it
        if (this.selectedQuantity > 5000 && !this.expandedQuantities) {
          setTimeout(() => {
            this.toggleExtendedQuantities();
          }, 100); // Small delay to ensure row selection styling is applied first
        }
      }
    }
  }

  updateSelectedQuantityDisplay() {
    // Update any selected quantity display elements
    const selectedQtyElements = document.querySelectorAll('.selected-quantity-display');
    selectedQtyElements.forEach(el => {
      el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : '';
    });

    // Update order summary
    this.updateOrderSummary();
  }

  updateOrderSummary() {
    if (!this.selectedQuantity) return;

    // Get current pricing for display calculations
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    const variant = variants[this.selectedQuantity.toString()];

    if (!variant) {
      console.warn(`Variant not found for quantity: ${this.selectedQuantity}`);
      return;
    }

    let unitPrice = this.calculateUnitPrice();
    let rushFee = 0;
    let totalPrice = this.selectedQuantity * unitPrice;

    // Add rush surcharge (for display purposes)
    if (this.isRushed) {
      const baseTotalPrice = this.calculateVariantTotalPrice();
      rushFee = Math.round(baseTotalPrice * (this.RUSH_MULTIPLIER - 1));
      document.getElementById('summary-rush-row').style.display = '';
      document.getElementById('summary-rush-fee').textContent = `$${rushFee.toFixed(2)}`;
      totalPrice += rushFee;
    } else {
      document.getElementById('summary-rush-row').style.display = 'none';
      document.getElementById('summary-rush-fee').textContent = '$0.00';
    }

    // Update summary elements
    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');

    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();
    if (summaryUnitPrice) summaryUnitPrice.textContent = `$${unitPrice.toFixed(2)}`;
    if (summaryTotal) summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;
  }

  async addToCart() {
    console.log('addToCart function called');
    const button = document.getElementById('custom-add-to-cart-btn');
    if (!button) {
      console.error('Add to cart button not found in addToCart function');
      return;
    }

    console.log('Current selection:', {
      size: this.selectedSize,
      printType: this.selectedPrintType,
      quantity: this.selectedQuantity,
      isRushed: this.isRushed
    });

    // Show loading state
    button.classList.add('loading');
    button.disabled = true;

    try {
      // Get the correct variant ID based on size, print type, and quantity
      const pricingKey = this.getPricingKey();
      const quantityKey = String(this.selectedQuantity);
      const variantId = this.variantMapping[pricingKey]?.[quantityKey];

      console.log('[AddToCart Debug] Pricing key:', pricingKey);
      console.log('[AddToCart Debug] Quantity key:', quantityKey);
      console.log('[AddToCart Debug] Selected variant ID:', variantId);

      if (!variantId) {
        throw new Error(`No variant found for ${pricingKey} - ${quantityKey} units.`);
      }

      // Create FormData to handle file upload
      const formData = new FormData();

      // Shared group id so the coaster and its rush fee stay linked in the cart
      // (cart grouping keys off _epk_group). Without this the rush fee renders as
      // a separate, unlinked card.
      const epkGroup = 'epkorder-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1000000).toString(36);

      // Add the main coaster variant
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', '1');
      formData.append('items[0][properties][Shape]', this.selectedSize);
      formData.append('items[0][properties][Print Side]', this.selectedPrintType === 'FrontOnly' ? 'Front Only' : 'Front & Back');
      formData.append('items[0][properties][Print Type]', this.selectedColourType || 'Full Colour');
      formData.append('items[0][properties][Quantity]', this.selectedQuantity);
      formData.append('items[0][properties][Price/Unit]', `$${this.calculateUnitPrice().toFixed(2)}`);
      formData.append('items[0][properties][_epk_group]', epkGroup);

      // Add the uploaded files
      const fileInput1 = document.querySelector('input[type="file"][name="properties[Design File]"]');
      if (fileInput1 && fileInput1.files[0]) {
        formData.append('items[0][properties][Design File]', fileInput1.files[0]);
      }

      const fileInput2 = document.querySelector('input[type="file"][name="properties[Back Design File]"]');
      if (fileInput2 && fileInput2.files[0] && this.selectedPrintType === 'FrontBack') {
        formData.append('items[0][properties][Back Design File]', fileInput2.files[0]);
      }

      let itemIndex = 1; // Start next items at index 1

      // Add rush fee as separate product if rushed is selected
      if (this.isRushed) {
        const variantTotalPrice = this.calculateVariantTotalPrice();
        const rushFeeAmount = variantTotalPrice * (this.RUSH_MULTIPLIER - 1);
        const rushFeeQuantity = Math.round(rushFeeAmount);

        formData.append(`items[${itemIndex}][id]`, '50675778126106');
        formData.append(`items[${itemIndex}][quantity]`, rushFeeQuantity);
        formData.append(`items[${itemIndex}][properties][Base Order Total]`, `$${variantTotalPrice.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][Rush Fee (5 business days) +30%]`, `$${rushFeeAmount.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][_epk_group]`, epkGroup);
      }

      // Submit to cart using FormData (supports file uploads)
      const response = await fetch('/cart/add', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add to cart: ${response.status} - ${errorText}`);
      }

      // Success
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Set flag for success state after page refresh
      localStorage.setItem('cartAddSuccess', 'true');
      // Reload page to update cart UI (since we're using form submission)
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error('Cart error:', error);
      this.showMessage(`Error adding to cart: ${error.message}`, 'error');
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }

  showMessage(text, type) {
    console.log('showMessage called:', text, type);

    // Remove existing messages
    const existingMessages = document.querySelectorAll('.coasters-message');
    existingMessages.forEach(msg => msg.remove());

    // Create new toast message
    const message = document.createElement('div');
    message.className = `coasters-message coasters-${type}-message coasters-toast-message`;
    message.textContent = text;

    // Position the toast near the Add to cart button
    const addToCartButton = document.querySelector('#custom-add-to-cart-btn') ||
      document.querySelector('.custom-add-to-cart-button') ||
      document.querySelector('.product-form-coasters__cart-submit') ||
      document.querySelector('#product-form-coasters button[type="submit"]') ||
      document.querySelector('button[name="add"]');

    console.log('Found button:', addToCartButton);

    if (addToCartButton) {
      const buttonRect = addToCartButton.getBoundingClientRect();
      console.log('Button rect:', buttonRect);

      // Position the toast near the button
      message.style.position = 'fixed';
      message.style.top = `${buttonRect.top + (buttonRect.height / 2) - 30}px`;
      message.style.right = '20px';
      message.style.zIndex = '9999';

      document.body.appendChild(message);
      console.log('Toast appended to body');

      // Apply styles
      message.style.cssText += `
        background: ${type === 'success' ? '#059669' : '#dc2626'};
        color: white;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        font-weight: 500;
        box-shadow: 0 8px 16px rgba(0,0,0,0.2);
        opacity: 1;
        transform: translateX(0);
        transition: all 0.3s ease;
        max-width: 300px;
        word-wrap: break-word;
      `;

      // Auto-hide after 4 seconds
      setTimeout(() => {
        message.style.transform = 'translateX(100%)';
        message.style.opacity = '0';
        setTimeout(() => {
          if (message.parentNode) {
            message.remove();
          }
        }, 300);
      }, 4000);

    } else {
      console.warn('Add to cart button not found for toast positioning');

      // Fallback: append to body with default positioning
      message.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: ${type === 'success' ? '#059669' : '#dc2626'};
        color: white;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        font-weight: 500;
        box-shadow: 0 8px 16px rgba(0,0,0,0.2);
        z-index: 9999;
        max-width: 300px;
        word-wrap: break-word;
      `;

      document.body.appendChild(message);

      // Auto-hide after 4 seconds
      setTimeout(() => {
        if (message.parentNode) {
          message.remove();
        }
      }, 4000);
    }
  }

  decimalToFraction(decimal) {
    if (decimal === 1) return '1';
    if (decimal === 0.5) return '½';
    if (decimal === 0.25) return '¼';
    if (decimal === 0.75) return '¾';
    if (decimal === 0.2) return '⅕';
    if (decimal === 0.4) return '⅖';
    if (decimal === 0.6) return '⅗';
    if (decimal === 0.8) return '⅘';
    return decimal.toFixed(1);
  }

  updateMediaGalleryForSelectedVariant() {
    const pricingKey = this.getPricingKey();
    const variants = this.variantMapping[pricingKey];
    const variantId = variants[this.selectedQuantity.toString()];

    if (!variantId) return;

    // Update URL with selected variant
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);

    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);

    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }

      const productData = JSON.parse(productScript.textContent);
      const variant = productData.variants?.find(v => v.id == variantId);

      if (!variant || !variant.featured_media?.id) {
        console.log('No variant or featured media found for:', variantId);
        return;
      }

      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);

      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }

      // Get the section ID from the media gallery
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${variant.featured_media.id}`;

      console.log('Looking for media with ID:', targetMediaId);

      // Find the thumbnail with the matching data-target
      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          console.log('Found thumbnail button, clicking it');
          button.click();
          return;
        }
      }

      // Fallback: directly call setActiveMedia if thumbnail click didn't work
      console.log('Thumbnail not found, using direct media switching');
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
      } else {
        // Manual fallback
        this.manualMediaSwitch(targetMediaId);
      }

    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }

  manualMediaSwitch(targetMediaId) {
    console.log('Manual media switch to:', targetMediaId);

    // Try to find and activate the target media
    const targetMedia = document.getElementById(targetMediaId);
    if (targetMedia) {
      // Hide all media
      const allMedia = document.querySelectorAll('[id*="-"][id*="media"]');
      allMedia.forEach(media => {
        media.style.display = 'none';
        media.classList.remove('active');
      });

      // Show target media
      targetMedia.style.display = 'block';
      targetMedia.classList.add('active');

      // Update thumbnails
      const allThumbnails = document.querySelectorAll('[data-target]');
      allThumbnails.forEach(thumb => thumb.classList.remove('active'));

      const targetThumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (targetThumbnail) {
        targetThumbnail.classList.add('active');
      }

      console.log('Manual media switch completed');
    } else {
      console.log('Target media not found:', targetMediaId);
    }
  }

  checkCartAddSuccess() {
    const successFlag = localStorage.getItem('cartAddSuccess');
    if (successFlag === 'true') {
      localStorage.removeItem('cartAddSuccess');
      this.showMessage('Added to cart successfully!', 'success');
    }
  }

  preventAutoScroll() {
    // Prevent automatic scrolling behaviors that might interfere with user experience
    // But allow manual scrolling functions like scrollToShippingCalculator
    const blockScrollIntoView = () => {
      const originalScrollIntoView = Element.prototype.scrollIntoView;
      Element.prototype.scrollIntoView = function (options) {
        // Allow manual scrolling (when called by our functions)
        if (options && (options.block === 'manual' || options.behavior === 'smooth')) {
          return originalScrollIntoView.call(this, options);
        }
        // Block automatic scrolling
        console.log('Blocked automatic scrollIntoView');
        return;
      };
    };

    // Apply the scroll blocking
    blockScrollIntoView();

    // Also prevent hash-based scrolling on page load
    if (window.location.hash) {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 1);
    }

    // Prevent scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Block automatic focus scrolling but allow manual focus
    const originalFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function (options) {
      const newOptions = { ...options, preventScroll: true };
      return originalFocus.call(this, newOptions);
    };
  }
}

// Initialize the product when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Only initialize if we're on a product page with the coaster-specific elements
  if (document.querySelector('.size-btn') || document.querySelector('#quantity-grid-body')) {
    new CoastersProduct();
  }
});

// Smooth scroll function for ETA button
function scrollToShippingCalculator(event) {
  event.preventDefault();

  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Smooth scroll function for ETA calculator
function scrollToEtaCalculator(event) {
  event.preventDefault();

  const etaCalculatorSection = document.getElementById('eta-calculator-section');
  if (etaCalculatorSection) {
    etaCalculatorSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Legacy function for backwards compatibility
function scrollToDesignUpload(event) {
  event.preventDefault();

  const designUploadSection = document.getElementById('design-upload-section');
  if (designUploadSection) {
    designUploadSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Test function for toast messages
function testToast() {
  const product = new CoastersProduct();
  product.showMessage('Test message!', 'success');
}

// Coasters don't have member discounts - remove any discount elements
function removeCoasterDiscountRows() {
  console.log('[Coasters] Aggressively removing any member discount elements');

  // Remove discount row from the product summary only (scoped)
  const discountRow = document.getElementById('summary-discount-row');
  if (discountRow) {
    console.log('[Coasters] Removing discount row from summary');
    discountRow.remove();
  }

  // Find and remove discount rows within the product summary container only
  const summaryBox = document.getElementById('order-summary') || document.querySelector('.order-summary');
  const allDiscountRows = summaryBox ? summaryBox.querySelectorAll('.summary-row') : [];
  allDiscountRows.forEach(row => {
    const text = row.textContent.toLowerCase();
    if (text.includes('discount') || text.includes('member') || text.includes('gold') || text.includes('silver') || text.includes('bronze') || text.includes('trade')) {
      console.log('[Coasters] Removing discount row by content:', text);
      row.remove();
    }
  });

  // Do NOT remove member discount elements globally; leave cart drawer/checkout intact

  // Force reset summary elements to simple pricing
  const summaryTotal = document.getElementById('summary-total');
  const summaryUnitPrice = document.getElementById('summary-unit-price');

  if (summaryTotal && summaryTotal.innerHTML.includes('member-price')) {
    console.log('[Coasters] Forcing summary total to simple pricing');
    summaryTotal.innerHTML = summaryTotal.textContent; // Strip any HTML formatting
  }

  if (summaryUnitPrice && summaryUnitPrice.innerHTML.includes('member-price')) {
    console.log('[Coasters] Forcing summary unit price to simple pricing');
    summaryUnitPrice.innerHTML = summaryUnitPrice.textContent; // Strip any HTML formatting
  }
}

// Set up observer to continuously remove discount elements on coasters page
document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('#product-form-coasters')) {
    console.log('[Coasters] Setting up discount element removal observer');

    // Remove immediately
    removeCoasterDiscountRows();

    // Set up observer to catch dynamically added elements
    const observer = new MutationObserver((mutations) => {
      // Only clean discount rows within the product order summary
      removeCoasterDiscountRows();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Also run periodically every 500ms for aggressive removal
    // Reduce frequency and scope of clean-up to avoid fighting with cart drawer/checkout
    setInterval(removeCoasterDiscountRows, 2000);
  }
});

// Force bold titles (utility function)
function forceBoldTitles() {
  const titles = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
  titles.forEach(title => {
    title.style.fontWeight = 'bold';
  });
}
